var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"mr-1 mr-2 px-3 py-3",attrs:{"text":""}},[_c('v-icon',[_vm._v("mdi-chevron-left")]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }